const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

// Export nommé et par défaut
export { BACKEND_URL };
export default BACKEND_URL;
